module.exports = __webpack_public_path__ + "static/img/bg_slogan@2x.9f4cd54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/ourMission/bg_slogan@2x.png
// module id = m0KB
// module chunks = 0